module.exports = __webpack_public_path__ + "img/zhumeng.457023f0.png";